import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  isEmptyOrWhitespace(value: string | null | undefined): boolean {
    return value === null || value === undefined || value.toString().trim().length === 0;
  }

  isValidPhoneNumber(phoneNumber: string | null | undefined): boolean {
    if (this.isEmptyOrWhitespace(phoneNumber)) {
      return false;
    }

    const phoneRegex = /^[\+]?[1-9][\d]{0,15}$/;
    const cleanPhone = phoneNumber!.toString().replace(/[\s\-\(\)]/g, '');
    return phoneRegex.test(cleanPhone) && cleanPhone.length >= 7;
  }

  isValidEmail(email: string | null | undefined): boolean {
    if (this.isEmptyOrWhitespace(email)) {
      return true; // Email is optional, so empty is valid
    }

    // Use browser's built-in email validation pattern
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    return emailRegex.test(email!.toString().trim());
  }
}
